import React from 'react';
import './su-components.css';

export interface SegmentToggleProps<T extends string> {
  options: [{ value: T; label: string }, { value: T; label: string }];
  value: T;
  onChange: (v: T) => void;
  /** pill (default): joined capsule. buttons: two separate outlined buttons that share the row. */
  variant?: 'pill' | 'buttons';
}

function SegmentToggle<T extends string>({ options, value, onChange, variant = 'pill' }: SegmentToggleProps<T>) {
  return (
    <div className={`su-toggle${variant === 'buttons' ? ' buttons' : ''}`} role="tablist">
      {options.map((o) => (
        <button
          key={o.value}
          type="button"
          role="tab"
          aria-selected={o.value === value}
          className={o.value === value ? 'active' : ''}
          onClick={() => onChange(o.value)}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}

export default SegmentToggle;
